export default {
      id: "spor_toto-usage",
      viewBox: "0 0 98 24",
      url: "/" + "images/icons.3.109.2.svg#spor_toto-usage",
      toString: function () {
        return this.url;
      }
    }